import { useFocusStore } from '@yeshuman/sdk'
import type { PluginAppRoute } from '@yeshuman/sdk'
import { Navigate, useParams } from 'react-router-dom'

import {
  ActivityPage,
  ConditionDetailPage,
  ConditionsPage,
  ConsultReportDetailPage,
  ConsultationsPage,
  HealthRecordDetailPage,
  InsightsPage,
  MeasurementsPage,
  NutritionPage,
  ObservationsPage,
  PatientsPage,
  PractitionerConsultationsPage,
  RecordsPage,
  SymptomsPage,
  TherapeuticsPage,
} from '../components'

function ConsultationsRoute() {
  const { focus } = useFocusStore()
  return focus?.current_focus === 'practitioner' ? (
    <PractitionerConsultationsPage />
  ) : (
    <ConsultationsPage />
  )
}

function ConsultReportRoute() {
  const { focus } = useFocusStore()
  return focus?.current_focus === 'practitioner' ? (
    <Navigate to="/practitioner" replace />
  ) : (
    <ConsultReportDetailPage />
  )
}

function HealthRecordLegacyRedirect() {
  const { recordId } = useParams<{ recordId: string }>()
  return <Navigate to={recordId ? `/records/${recordId}` : '/records'} replace />
}

function redirectTo(to: string) {
  return function HealthLegacyRedirect() {
    return <Navigate to={to} replace />
  }
}

export const HEALTH_PAGE_ROUTES: PluginAppRoute[] = [
  { path: '/activity', element: ActivityPage },
  { path: '/symptoms', element: SymptomsPage },
  { path: '/conditions', element: ConditionsPage },
  { path: '/conditions/:conditionId', element: ConditionDetailPage },
  { path: '/observations', element: ObservationsPage },
  { path: '/insights', element: InsightsPage },
  { path: '/measurements', element: MeasurementsPage },
  { path: '/therapeutics', element: TherapeuticsPage },
  { path: '/nutrition', element: NutritionPage },
  { path: '/records', element: RecordsPage },
  { path: '/records/:recordId', element: HealthRecordDetailPage },
  { path: '/consultations', element: ConsultationsRoute },
  { path: '/consultations/:reportId', element: ConsultReportRoute },
  { path: '/patients', element: PatientsPage },
  ...(
    [
      'activity',
      'symptoms',
      'observations',
      'insights',
      'measurements',
      'therapeutics',
      'nutrition',
      'records',
      'consultations',
      'patients',
    ] as const
  ).map((page) => ({ path: `/health/${page}`, element: redirectTo(`/${page}`) })),
  { path: '/health/records/:recordId', element: HealthRecordLegacyRedirect },
]
